const Reducer = (state, action) => {
  switch (action.type) {
    case 'DRIVER':
      return {
        ...state,
        driver: action.payload
      };
    case 'PERIOD':
      return {
        ...state,
        period: action.payload
      };
    case 'WORKDAY':
      return {
        ...state,
        workday: action.payload
      };
    case 'TRIP':
      return {
        ...state,
        trip: action.payload
      };
    case 'DAY_LABEL':
      return {
        ...state,
        daylabel: action.payload
      };
    default:
      return state;
  }
};

export default Reducer;